import { IHttpApi } from '@cian/http-api/shared';

import { assertUnknownError } from './assert';
import { mapAddOfferToComparisonResponse, mapAddOfferToComparisonResponseError } from './mappers';
import {
  fetchAddOfferToComparison,
  TAddOfferToComparisonRequest,
  TAddOfferToComparisonResponse,
} from '../../../repositories/offers-comparison/v2/add-offer-to-comparison';

export async function addOfferToComparisonRequest({
  httpApi,
  parameters,
}: {
  httpApi: IHttpApi;
  parameters: TAddOfferToComparisonRequest;
}): Promise<TAddOfferToComparisonResponse> {
  const response = await fetchAddOfferToComparison({
    httpApi,
    parameters,
    config: {},
    mappers: {
      200: mapAddOfferToComparisonResponse,
      400: mapAddOfferToComparisonResponseError,
    },
  });

  assertUnknownError(response);

  return response.response as TAddOfferToComparisonResponse;
}
